<template>
  <div>
    <div ref="widgetContainer">
      <Row class="widget-container">
        <i-col :lg="24" :md="24" :sm="24" :xs="24">
          <MainCard></MainCard>
        </i-col>
      </Row>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import MainCard from './MainCard';

  export default {
    name: 'GeneralDashboard',
    components: {MainCard},
    data() {
      return {}
    },
    computed: {
      ...mapGetters(['getDates', 'getEventId']),
    },
    watch: {},
    methods: {
      triggerExportPdf() {
        this.$emit('exportPdf', this.$refs.widgetContainer, 'testPDF.pdf')
      },
      getAllData(id) {
      }
    },
    mounted() {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/a_generalDashboard/GeneralDashboard.vue